import React from "react";
import { observer } from "mobx-react";

import { useStores } from "../../../context/StoreContext";
import { CustomizeViewDeviceHeader } from "./CustomizeViewDeviceHeader";
import { IViewDeviceHeaderProps } from "./IViewDeviceHeaderProps";
import { NewViewDeviceHeader } from "./NewViewDeviceHeader";

export const ViewDeviceHeader = observer(function ViewDeviceHeader(
    props: IViewDeviceHeaderProps,
) {
    const { viewId } = props;

    const { observeStore } = useStores();
    const showCustomizeHeader = observeStore.isCustomizing && viewId;
    if (showCustomizeHeader) {
        return <CustomizeViewDeviceHeader {...props} />;
    }

    return <NewViewDeviceHeader {...props} />;
});
